import useChatMedia from '~/App/Chats/hooks/useChatMedia'
import type { ChatThreadEvent } from '~/App/ChatThreads/@types'
import { IncomingImageMessage } from '~/App/components/messages/IncomingImageMessage'
import MessageText from '~/App/components/messages/MessageText'

type IncomingImageMessageContainerProps = {
  data: ChatThreadEvent
}

function ImageEvent({ data, ...props }: IncomingImageMessageContainerProps) {
  const { data: media } = useChatMedia(
    data.attributes.chat_id,
    data.attributes.sub_type === 'image'
      ? data.attributes.additional_fields.attachment.id
      : undefined,
  )

  if (data.attributes.sub_type !== 'image') {
    return null
  }

  return (
    <IncomingImageMessage
      src={media?.attributes.url}
      time={data.attributes.timestamp * 1000}
      {...props}
    >
      <MessageText>
        {data.attributes.text_in_chatter_language ||
          data.attributes.text ||
          data.attributes?.additional_fields?.caption}
      </MessageText>
    </IncomingImageMessage>
  )
}

export default ImageEvent
